import type { ReactNode } from 'react';
import { MdEdit } from 'react-icons/md';
import { Button } from '@/components/Button';

type Props = {
  heading: string;
  canEdit: boolean;
  onEdit: () => void;
  children: ReactNode;
};

export default function LinkedAccountFieldRow({ heading, canEdit, onEdit, children }: Props) {
  return (
    <div className="flex flex-col gap-xxs rounded-sm bg-white px-lg pt-md pb-lg shadow-layer1">
      <div className="flex items-center justify-between">
        <h2 className="text-heading-xs">{heading}</h2>
        {canEdit && (
          <Button type="button" color="tertiary" aria-label={`${heading}を編集`} onClick={onEdit}>
            <MdEdit size={20} />
            編集
          </Button>
        )}
      </div>
      {children}
    </div>
  );
}
